import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d3b9568"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "transfer-panel"
}

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { accountService } from '@exchange/libs/account/service/src';
import { marketService } from '@exchange/libs/market/service/src';
import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import { subaccountsService } from '@exchange/libs/trading-accounts/service/src';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { currencyService } from '@exchange/libs/utils/currency/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferPanel',
  props: {
  marketId: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });
const router = useRouter();

const market = computed(() => marketService.getMarket(props.marketId));
const isPerpetualMarket = computed(() => market.value?.type === MarketType.PERP);

const { accountId } = accountService;
const { currencies } = currencyService;

const mainAccount = computed(() => subaccountsService.list.value.find((account) => account.name === CONSTANTS.MAIN_SUBACCOUNT_NAME));
const mainAccountBalance = computed(() => {
  if (!mainAccount.value || !currencies.value) return 0;
  return mainAccount.value.getBalanceTotal(currencies.value).all;
});
const hasPositiveMainBalance = computed(() => {
  if (!mainAccountBalance.value) return false;
  return !mainAccountBalance.value.isZero?.();
});

const currentSubaccount = computed(() => subaccountsService.getAccountById(accountId.value));
const currentAccountBalance = computed(() => {
  if (!currentSubaccount.value || !currencies.value) return 0;
  return currentSubaccount.value.getBalanceTotal(currencies.value).all;
});
const hasZeroBalance = computed(() => {
  if (!currentAccountBalance.value) return true;
  return currentAccountBalance.value.isZero?.() || currentAccountBalance.value.eq(0);
});

const handleTransferClick = () => {
  router.push({
    ...router.currentRoute.value,
    hash: '#Transfer',
    query: {
      source: CONSTANTS.MAIN_SUBACCOUNT_NAME,
      destination: currentSubaccount.value?.name,
      currency: CONSTANTS.DEFAULT_CURRENCIES.fiat,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isPerpetualMarket.value && hasZeroBalance.value && hasPositiveMainBalance.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "transfer-panel__notice",
            onClick: handleTransferClick
          }, _toDisplayString(_unref(t)('warnings.transactions.subaccountTransfer.transferPanel.notice', {
            currentBalance: currentAccountBalance.value,
            mainBalance: mainAccountBalance.value,
          })), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})